import { ENGLISH } from "../../../public/Constants/EnumConstants";

export const CARD_CONTAINER_CLASS = "w-auto p-2 xl:p-0 md:w-[276px] mx-auto ";
export const IMAGE_CONTAINER_CLASS = " relative my-3 ";
export const INNER_CONTAINER_CLASS =
    "bg-Description_Banner bg-opacity-70 rounded-b-md absolute bottom-1 md:bottom-2 w-[100%] xl:w-[276px]  ";
const QOUTES_ICON_CLASS = "h-4 w-5 sm:h-8 sm:w-9";
const ARABIC_QOUTES_ICON_CLASS = "h-4 w-5 sm:h-8 sm:w-9 ml-auto";
export const IMAGE_STYLE = "rounded-lg bg-Secondary_Hover";
export const qoutesAligmentClass = (language) => {
    return language === ENGLISH ? QOUTES_ICON_CLASS : ARABIC_QOUTES_ICON_CLASS;
};
